module.exports = __webpack_public_path__ + "static/media/star_lineal.d02524a3.png";